import { default as VendorProfile } from "../views/vendors/partials/Profile";
import { default as VendorLocations } from "../views/vendors/locations/Locations";
import { default as VendorContacts } from "../views/vendors/contacts/Contacts";
import { default as VendorBilling } from "../views/vendors/billing/Billing";
import { default as VendorIntakeForm } from "../views/vendors/IntakeForm";
import { default as VendorFollowers } from "../views/vendors/Followers";
import { default as MainNetworks } from "../views/vendors/network/Index";
import { default as NetworkRequests } from "../views/vendors/network/NetworkRequests";
import { default as MyNetworks } from "../views/vendors/network/MyNetwork.vue";
import { default as MyAccount } from "../views/users/Account";
import { default as Vendors } from "../views/vendors/Index";
import { default as VendorShow } from "../views/vendors/Show";
const vendor = [
  {
    path: "/account",
    name: "myAccount",
    component: MyAccount,

    meta: {
      vendor: true,
    },
  },
  {
    path: "/my-vendors",
    component: Vendors,
    meta: {
      vendor: true,
    },
  },
  {
    path: "/vendors/:id",
    component: VendorShow,
    meta: {
      vendor: true,
    },
    children: [
      {
        path: "",
        name: "vendorProfile",
        component: VendorProfile,
      },
      {
        path: "locations",
        component: VendorLocations,
      },
      {
        path: "contacts",
        component: VendorContacts,
      },
      {
        path: "billing",
        component: VendorBilling,
      },
      {
        path: "intake-form",
        component: VendorIntakeForm,
      },
      {
        path: "network",
        component: MainNetworks,
        children: [
          {
            path: "requests",
            name: "vendorNetworksRequests",
            component: NetworkRequests,
          },
          {
            path: "mine",
            name: "myNetworks",
            component: MyNetworks,
          },
        ],
      },
      {
        path: "followers",
        component: VendorFollowers,
      },
    ],
  },
];

export default vendor;
